(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-blog-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  const blogEntriesWithoutImages = document.querySelectorAll('.blog-entries-without-images .blog-entry');

  // Function to update filter colors based on available blogs
  function updateFilterColors() {
    const alphabetTitles = document.querySelectorAll('.blog-filter-section h3');
    alphabetTitles.forEach(title => {
      const letter = title.innerText.trim();
      const hasBlogs = Array.from(blogEntriesWithoutImages).some(entry => entry.getAttribute('data-title').charAt(0).toUpperCase() === letter);
      title.style.color = hasBlogs ? 'black' : 'gray';
    
    });
  }

  // Initial update of filter colors
  updateFilterColors();
});
document.addEventListener('DOMContentLoaded', function() {
  const filters = document.querySelectorAll('.alphabet-filter');
  const blogEntries = document.querySelectorAll('.blog-entry');
  const blogEntriesWithoutImages = document.querySelectorAll('.blog-entries-without-images .blog-entry');

  filters.forEach(filter => {
    filter.addEventListener('click', function(event) {
      event.preventDefault();
      const letter = this.getAttribute('data-letter');

      // Scroll to the corresponding section in the bottom list
      const targetSection = document.querySelector(`#filter-${letter}`);
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth' });
      }

      // Change the color of the alphabet letters based on availability of blogs
      filters.forEach(f => {
        const filterLetter = f.getAttribute('data-letter');
        const hasBlogs = Array.from(blogEntriesWithoutImages).some(entry => entry.getAttribute('data-title') === filterLetter);
        f.style.color = hasBlogs ? 'black' : 'gray';
      });
    });
  });

  // Initial filter color update
  filters.forEach(f => {
    const filterLetter = f.getAttribute('data-letter');
    const hasBlogs = Array.from(blogEntriesWithoutImages).some(entry => entry.getAttribute('data-title') === filterLetter);
    f.style.color = hasBlogs ? 'black' : 'gray';
  });
});

  } catch(e) { console.error(e); }
})();
})();
